import axios from 'axios'

export function fetchSites() {
  return (dispatch, getState) => {
    dispatch({
      type: 'SITES_FETCH',
      payload: axios(`/sites`)
    })
  }
}

export function getSite(companyParam,siteParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'SITE_FETCH',
      payload: axios(`/companies/${companyParam}/sites/${siteParam}`)
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/SiteActions.js